import { render, staticRenderFns } from "./BaseFilterStatusSubmission.vue?vue&type=template&id=2d8ae017&scoped=true&"
import script from "./BaseFilterStatusSubmission.vue?vue&type=script&lang=js&"
export * from "./BaseFilterStatusSubmission.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilterStatusSubmission.vue?vue&type=style&index=0&id=2d8ae017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ae017",
  null
  
)

export default component.exports